// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"6eb47215","239":"e5a34166","453":"8614574d","455":"e6a06ea3","977":"c016084b"}[chunkId] + ".chunk.js";
};